/**
 * A card payment that needs 3D Secure comes back from `MakePayment` with a bank URL
 * instead of a finalized cart — the browser must leave the SPA, authenticate at the
 * bank, and land back on `/payment/return` (the `returnUrl` PaymentForm builds). The
 * URL shows up as either a top-level `continueUrl` or nested under `bankResponse`
 * depending on the provider.
 */
interface PaymentLike {
  continueUrl?: string | null;
  bankResponse?: { continueUrl?: string | null; redirectUrl?: string | null } | null;
}

export function extractContinueUrl(res: unknown): string | undefined {
  const r = (res ?? {}) as PaymentLike;
  if (r.continueUrl) return r.continueUrl;
  return r.bankResponse?.continueUrl ?? r.bankResponse?.redirectUrl ?? undefined;
}

/** Full-page navigate to the bank's 3DS page. Returns true if a redirect was started. */
export function redirectToBankIfNeeded(res: unknown): boolean {
  const url = extractContinueUrl(res);
  if (!url) return false;
  window.location.assign(url);
  return true;
}
